import React from 'react';
import {
    Flex,
    Grid,
    Text,
    GridProps,
} from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { NavigationSection } from 'features/navigation';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import { useNavigationBlockState } from '../store';

export type NavigationBlockProps = GridProps & React.RefAttributes<HTMLDivElement>

export const NavigationBlock: React.FC<NavigationBlockProps> = ({
    ...props
}) => {
    const {
        cateringEventCategories,
        cateringEventFormats,
        cateringFormats,
        culinaryStudioArticleCategories,
        deliveryArticleCategories,
        deliveryArticleTags,
        outdoorBarArticleCategories,
        sweetShopArticleCategories,
    } = useNavigationBlockState();

    return (
        <Grid
            {...props}
        >
            <Grid
                background="#E74C3C"
            >
                <Flex
                    padding="2rem"
                    background="#E74C3C"
                    flexDirection="row"
                    gap="2rem"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    wrap="wrap"
                >
                    <Link to="/">
                        <Text
                            color="white"
                            textDecoration="underline"
                            fontSize="2rem"
                            fontWeight="bold"
                        >
                            О нас
                        </Text>
                    </Link>
                    <Link to="/portfolio-events">
                        <Text
                            color="white"
                            textDecoration="underline"
                            fontSize="2rem"
                            fontWeight="bold"
                        >
                            Портфолио
                        </Text>
                    </Link>
                    <Link to="/places">
                        <Text
                            color="white"
                            textDecoration="underline"
                            fontSize="2rem"
                            fontWeight="bold"
                        >
                            Партнёрские площадки
                        </Text>
                    </Link>
                </Flex>
            </Grid>
            <NavigationSection
                cateringEventCategories={cateringEventCategories}
                cateringEventFormats={cateringEventFormats}
                cateringFormats={cateringFormats}
                culinaryStudioArticleCategories={culinaryStudioArticleCategories}
                deliveryArticleCategories={deliveryArticleCategories}
                deliveryArticleTags={deliveryArticleTags}
                outdoorBarArticleCategories={outdoorBarArticleCategories}
                sweetShopArticleCategories={sweetShopArticleCategories}
            />
        </Grid>
    );
};
